function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { combineReducers } from 'redux';
import { routerReducer } from 'redux-first-routing';
import App from 'modules/App';
import Account from 'modules/Account';
import Country from 'modules/Country';
/**
 * Here go all core non-dynamic reducers
 * @returns {{router: routerReducer}}
 */ export function getCoreReducers() {
    return {
        router: routerReducer,
        [App.constants.MODULE_ID]: App.reducer,
        [Account.constants.MODULE_ID]: Account.reducer,
        [Country.constants.MODULE_ID]: Country.reducer
    };
}
export default function createReducer(asyncReducers = {}) {
    const coreReducers = getCoreReducers();
    return combineReducers(_object_spread({}, coreReducers, asyncReducers));
}
